<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import { mapGetterts, mapGetters } from 'vuex'
export default
{
    mixins: [ adminTable ],

    data()
    {
        return {
            data: [],
            url: '/v1/admin/locationcities',
            tableName: 'tableCities',
            emptyModel: { name: null, attachments: [] },
            columns: [ 'id', 'name', 'created_at', 'updated_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    name: this.$t('PLACE.NAME'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                },
                columnsDisplay: { 'updated_at': 'not_desktop'  },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'created_at', 'updated_at'],
            },
        }
    },


}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('PLACE.CITY') }}</span>
            <mv-city-form :model="model" :edit="formEdit" @save="saveForm"></mv-city-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.PLACES') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="child_row" slot-scope="props">
                        <mv-attachment class="attachment-image" v-for="img in props.row.attachments" :key="img.id" :attachment="img">
                        </mv-attachment>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Cities.vue